import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CreateOrderTypeRequestDTO, OrderTypeResponseDTO } from 'typings/dto/orderType';
import IOrderTypeActionsService from './IOrderTypeActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class OrderTypeActionsServiceImpl
  extends ModelActionsService<OrderType, CreateOrderTypeRequestDTO, OrderTypeResponseDTO>
  implements IOrderTypeActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.orderType.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };
}
